<template>
  <div data-tour-scope="setting-permissions-profile">
    <v-main>
      <v-container fluid fill-height>
        <v-layout justify-center align-center v-resize="onResize">

          <v-card width="100%" outlined elevation-0>
            <v-toolbar flat class="border_bottom" shaped>
              <v-toolbar-title>
                {{ this.$vuetify.lang.t('$vuetify.front.permissions') }}
              </v-toolbar-title>
              <v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-toolbar-items shift>
              </v-toolbar-items>
            </v-toolbar>


            <v-container fluid v-if="rendered">
              <v-card data-tour="table">
                <v-card-title>
                  <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                  ></v-text-field>
                </v-card-title>
                <v-data-table
                    :headers="headers"
                    :items="item.profiles"
                    :items-per-page="5"
                    class="elevation-1"
                    :search="search"
                    :hide-default-header="mobileCards"
                    :class="{ 'table-cards': mobileCards }"
                >
                  <!-- telefono: ogni profilo diventa una card; su desktop lo slot non esiste e resta la tabella -->
                  <template v-if="mobileCards" v-slot:body="{ items }">
                    <tbody class="profile-cards">
                      <tr v-for="profile in items" :key="profile._id">
                        <td :colspan="headers.length" class="px-3 py-1">
                          <key-value-card :title="profile.name || 'Profilo'" :fields="[{ label: 'Id', value: profile._id }]">
                            <template v-slot:actions>
                              <v-btn icon small color="primary" data-tour="edit-open" title="Modifica permessi" @click="openEditItem(profile)">
                                <v-icon small>mdi-pencil</v-icon>
                              </v-btn>
                            </template>
                          </key-value-card>
                        </td>
                      </tr>
                      <tr v-if="!items.length">
                        <td :colspan="headers.length" class="text-center grey--text py-6">Nessun profilo</td>
                      </tr>
                    </tbody>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-icon
                        small
                        class="mr-2"
                        data-tour="edit-open"
                        @click="openEditItem(item)"
                    >
                      mdi-pencil
                    </v-icon>
                  </template>
                </v-data-table>
              </v-card>

              <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition" v-if="editItem.name">
                <v-card data-tour="profile-dialog">
                  <v-toolbar dark color="primary">
                    <v-btn icon dark data-tour="profile-close" @click="dialog = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Settings</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                      <v-btn dark text @click="save">
                        Save
                      </v-btn>
                    </v-toolbar-items>
                  </v-toolbar>

                  <v-container>
                    <v-row>
                      <v-col cols="12" class="pt-0 pb-0">
                        <v-subheader><strong>{{editItem.name}}</strong></v-subheader>
                      </v-col>
                      <v-flex md12 class="d-flex pt-1">
                        <v-divider class="marg-title"></v-divider>
                      </v-flex>
                      <v-col cols="12" sm="3" md="3" v-for="(module,index) in item.permissions.list" :key="'module'+index" class="ma-0 pl-2 pr-2 pt-0 pb-0">
                        <v-checkbox :label="module" color="primary" hide-details dense v-model="editItem.modules.includes(module)" @change="permissionHandling($event, editIndex, module)"></v-checkbox>
                      </v-col>
                    </v-row>
                    <v-flex md12 class="d-flex pa-5">
                      <v-divider class="marg-title"></v-divider>
                    </v-flex>
                  </v-container>
                </v-card>
              </v-dialog>
            </v-container>

          </v-card>
          <v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'"
                      :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
            {{ snackbar.text }}
            <v-btn dark text
                   @click="snackbar.snackbar = false">
              Close
            </v-btn>
          </v-snackbar>
        </v-layout>
      </v-container>

    </v-main>
    <TourOverlay :tour="tour"></TourOverlay>
  </div>
</template>

<script>

import axios from 'axios'
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createPermissionsByProfileTourSteps } from './permissions-by-profile-tour';
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  name: "PermissionsByProfile",
  components: {
    KeyValueCard,
    TourOverlay,
  },
  setup() {
    return { tour: useTour(createPermissionsByProfileTourSteps()) };
  },
  beforeDestroy() {
    this.tour.stop();
  },
  data() {
    return {
      rendered: false,
      search: '',
      dialog: false,
      item: {
        profiles:[],
        permissions:{
          list:[]
        }
      },
      editItem: {},
      editIndex: null,
      headers: [
        { text: '_id', align: 'start', value: '_id',},
        { text: 'Name', value: 'name' },
        { text: '', value: 'actions', sortable: false}
      ],
      snackbar: {
        snackbar: false,
        color: '',
        mode: '',
        timeout: 6000,
        text: '',
      },
    }
  },

  async created() {
    this.setPreload(true);
    this.item = await this.getList();
    this.rendered = true;
    this.setPreload(false);
  },

  computed: {
    // sotto i 769px le righe diventano card
    mobileCards() {
      return this.$vuetify.breakpoint.width < 769;
    },
    ...mapGetters({

    }),
  },

  methods: {
    ...mapMutations({
      'setPreload': 'settings/setPreload',
    }),
    ...mapActions({
      'getList': 'permissions/getListByProfile',
      'updateItem': 'permissions/permissionUpdateByProfile'
    }),


    openEditItem (item) {
      this.editItem = null
      this.editIndex = this.item.profiles.indexOf(item)
      this.editItem = Object.assign({}, item)
      this.dialog = true
    },


    permissionHandling($event, idx, module){
      if($event){
        this.item.profiles[idx].modules.push(JSON.parse(JSON.stringify(module)))
      }else {
        this.item.profiles[idx].modules = this.item.profiles[idx].modules.filter((x)=>{
          return x !== module
        })
      }
    },
    async save() {

      this.setPreload(true);

      let result = await this.updateItem(this.editItem)



      if(result.success){

        this.setPreload(false);
        this.snackbar.color = "success";
        this.snackbar.text = "Operazione effettuata con  successo";
        this.snackbar.snackbar = true;
        this.snackbar.mode = 'multi-line';
        this.snackbar.timeout = 5000;
        this.dialog = false;
      }else {

        this.snackbar.color = "error";
        this.snackbar.text = result;
        this.snackbar.snackbar = true;
        this.snackbar.mode = 'multi-line';
        this.snackbar.timeout = 5000;
        this.setPreload(false);
        this.dialog = false;

      }

    },

    onResize() {
      this.isMobile = window.innerWidth < 769;
    },


  },
  beforeDestroy() {
    this.destroyData()
  }
}
</script>

<style>

</style>

<style scoped>
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.profile-cards,
.profile-cards tr {
	display: block;
	width: 100%;
}
.profile-cards tr,
.profile-cards tr:hover {
	background: transparent !important;
}
.profile-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.profile-cards tr:first-child td {
	padding-top: 12px !important;
}
.profile-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.profile-cards tr + tr td {
	padding-top: 8px !important;
}
</style>
